import { c as _c } from "react/compiler-runtime";
import { Typography, Icon } from "@/shared/ui/atoms";
import { useSearchUiStore } from "@/features/search/model/ui/store";
interface RegionModalSideBarProps {
  selectedRegion: number;
  setSelectedRegion: (region: number) => void;
}
const RegionModalSideBar = t0 => {
  const $ = _c(11);
  const {
    selectedRegion,
    setSelectedRegion
  } = t0;
  const {
    regionList
  } = useSearchUiStore();
  let t1;
  if ($[0] !== selectedRegion) {
    t1 = regionId => {
      if (selectedRegion === regionId) {
        return "text-[#1D1E20] font-semibold bg-[#F4F4F5]";
      }
    };
    $[0] = selectedRegion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getCheckedStyle = t1;
  let t2;
  if ($[2] !== getCheckedStyle || $[3] !== regionList || $[4] !== setSelectedRegion) {
    let t3;
    if ($[6] !== getCheckedStyle || $[7] !== setSelectedRegion) {
      t3 = region => <li key={region.id} className={`flex items-center justify-between gap-2 py-3 pl-5 pr-[10px] text-[#878A93] ${getCheckedStyle(region.id)}`} onClick={() => setSelectedRegion(region.id)}><Typography size={16} lineHeight={24} className="font-medium">{region.name}</Typography><Icon src="/icons/direction-black.svg" alt="search-icon" width={14} className="rotate-180" /></li>;
      $[6] = getCheckedStyle;
      $[7] = setSelectedRegion;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = regionList.map(t3);
    $[2] = getCheckedStyle;
    $[3] = regionList;
    $[4] = setSelectedRegion;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <aside className="min-h-0 w-2/5 shrink-0 overflow-y-auto"><ul className="border-r border-[#EAEBEC]">{t2}</ul></aside>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default RegionModalSideBar;